import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'
import { INotificationTemplate } from 'legacy/lut/classes/models/onboarding/INotificationTemplate'
import { ERequestTemplateNotificationType } from 'legacy/lut/classes/models/onboarding/RequestTemplate'
import { ActionNotifMode } from 'legacy/lut/components/widgets/public/onboarding/templates/actionDetail/ActionNotificationDetail'

import { EventBus } from 'core-components/classes/events/Bus'
import {
  IDataProviderFilter,
  IDataProviderSort,
  IPaging,
  IPagingFromTo,
} from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'
import {
  notificationTemplateApi,
  TApplyWrapperOptions,
  TCheckCanApplyWrapperResult,
  TNotificationLocaleOption,
} from 'onboarding/api/notificationTemplateApi'
import {
  TCreateNotificationTemplatePayload,
  TNotificationTemplateDB,
  TUpdateNotificationTemplatePayload,
} from 'onboarding/classes/models/notificationTemplate'

export enum NotificationTemplateEvent {
  onSavedLocale = 'onSavedLocale',
  onHidLocale = 'onHidLocale',
  onHidAllLocales = 'onHidAllLocales',
}

class NotificationTemplateService {
  public readonly eventBus: EventBus

  constructor() {
    this.eventBus = new EventBus(Object.values(NotificationTemplateEvent), this.constructor.name)
  }

  public getActiveUniqueNamesCrud(excludeUUIDs?: string[]) {
    return notificationTemplateApi.getActiveUniqueNamesCrud(excludeUUIDs)
  }

  public getById(id: number) {
    return notificationTemplateApi.getById(id)
  }

  public getActiveWrappersCrud() {
    return notificationTemplateApi.getActiveWrappersCrud()
  }

  public fetchMany(
    filter: IDataProviderFilter,
    paging: IPaging | IPagingFromTo,
    sort: IDataProviderSort | IDataProviderSort[] | undefined
  ) {
    return notificationTemplateApi.fetchMany(filter, paging, sort)
  }

  public fetchWrappers(
    paging: IPaging | IPagingFromTo,
    sort: IDataProviderSort | IDataProviderSort[] | undefined
  ) {
    return notificationTemplateApi.fetchWrappers(paging, sort)
  }

  public getListSource() {
    return CrudStore.get(CrudStoreItemOnboarding.NotificationTemplatesUniqList)
  }

  public fetchActiveLocales(templateName: string): Promise<INotificationTemplate[]> {
    return notificationTemplateApi.fetchActiveLocales(templateName)
  }

  public fetchLocaleOptions(): Promise<TNotificationLocaleOption[]> {
    return notificationTemplateApi.fetchLocaleOptions()
  }

  public createActiveOne(
    payload: TCreateNotificationTemplatePayload
  ): Promise<TNotificationTemplateDB> {
    return notificationTemplateApi.createActiveOne(payload)
  }

  public updateOne(
    uuid: string,
    payload: TUpdateNotificationTemplatePayload
  ): Promise<TNotificationTemplateDB> {
    return notificationTemplateApi.updateOne(uuid, payload)
  }

  public hideAllLocalesByUuid(templateName: string): Promise<boolean> {
    return notificationTemplateApi.hideAllLocalesByUuid(templateName)
  }

  public hideOne(uuid: string): Promise<boolean> {
    return notificationTemplateApi.hideOne(uuid)
  }

  public checkCanApplyWrapper(
    wrapperUuid: string,
    targetUuid: string
  ): Promise<TCheckCanApplyWrapperResult> {
    return notificationTemplateApi.checkCanApplyWrapper(wrapperUuid, targetUuid)
  }

  public applyWrapperToLocales(
    wrapperUuid: string,
    targetUuid: string,
    options: TApplyWrapperOptions
  ): Promise<true> {
    return notificationTemplateApi.applyWrapperToLocales(wrapperUuid, targetUuid, options)
  }

  public renewAllInheritedNotificationTemplates(notificationTemplateUUID: string) {
    return notificationTemplateApi.renewAllInheritedNotificationTemplates(notificationTemplateUUID)
  }

  public renewNotificationInActionTemplate(payload: {
    actionTemplateUUID: string
    notificationTemplateUUID: string
    notificationType: ActionNotifMode
  }) {
    return notificationTemplateApi.renewNotificationInActionTemplate(payload)
  }

  public renewNotificationInRequestTemplate(payload: {
    requestTemplateUUID: string
    notificationTemplateUUID: string
    notificationType: ERequestTemplateNotificationType
  }) {
    return notificationTemplateApi.renewNotificationInRequestTemplate(payload)
  }

  public renewNotificationInTransitionTemplate(payload: {
    transitionTemplateId: number
    notificationTemplateUUID: string
  }) {
    return notificationTemplateApi.renewNotificationInTransitionTemplate(payload)
  }
}

export const notificationTemplateService = new NotificationTemplateService()
